import { GET_CUSTOMER_REQUESTED, GET_MATRIXCUSTOMER_REQUESTED, GET_TICKETCUSTOMER_REQUESTED, UPDATE_CUSTOMER_REQUESTED } from "resources/actionTypes";

export function getCustomer(data) {
  return {
    type: GET_CUSTOMER_REQUESTED,
    payload:data
  };
}

export function getMatrixCustomer(data) {
  return {
    type: GET_MATRIXCUSTOMER_REQUESTED,
    payload: data,
  };
}

export function getTicketCustomer(data) {
  return {
    type: GET_TICKETCUSTOMER_REQUESTED,
    payload: data,
  };
}

export function patchUpdateCustomer(userUpdateCustomer) {
  const data ={
    userUpdateCustomer:userUpdateCustomer,
  }
  return {
    type: UPDATE_CUSTOMER_REQUESTED,
    payload: data,
  };
}
